import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState } from 'react';
import { View, Text, Dimensions, Pressable, StyleSheet } from 'react-native';
import { Order } from '../../Order/rn';
import { useLocale } from '../../LocaleProvider/rn';
import ImageIconRight from '../../../assets/images/rn/ArrowRightRed';
import ImageIconRightGray from '../../../assets/images/rn/ArrowRightGray';
import { Popup } from '../../Popup/rn';
import { ProductListTabs } from '../../ProductList/rn/ProductListTabs'; // import { ProductCardProps } from '../../ProductCard/rn';

import { BUYER_ORDER_LIST_TITLE_TEXT } from '../../../utils/constants';
import { FONT_WEIGHT_MEDIUM, FONT_WEIGHT_REGULAR } from '../../../styles/rn';
// import { useComponentTracking } from '../../../hooks/useTracking';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
export var OrderWithMoreBtn = function OrderWithMoreBtn(props) {
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var title = props.title,
    order = props.order,
    _props$loadMoreOrderT = props.loadMoreOrderText,
    loadMoreOrderText = _props$loadMoreOrderT === void 0 ? trans('more_order_text') : _props$loadMoreOrderT,
    tabs = props.tabs,
    onLoadMore = props.onLoadMore,
    defaultSelected = props.defaultSelected,
    itemText = props.itemText,
    itemsText = props.itemsText,
    panelTitleText = props.panelTitleText,
    showUserTypeTab = props.showUserTypeTab,
    userTypeTabs = props.userTypeTabs,
    _onButtonClick = props.onButtonClick,
    componentTrackingData = props.componentTrackingData,
    _props$showLoading = props.showLoading,
    showLoading = _props$showLoading === void 0 ? true : _props$showLoading,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$showMoreButton = props.showMoreButton,
    showMoreButton = _props$showMoreButton === void 0 ? true : _props$showMoreButton,
    showOrderId = props.showOrderId,
    onClosePopup = props.onClosePopup,
    popupContentStyle = props.popupContentStyle,
    isUIOptimisationHotQuestion = props.isUIOptimisationHotQuestion;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var _useComponentTracking = useComponentTracking({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    orderCardTracking = _useComponentTracking2.orderCard,
    moreOrderTracking = _useComponentTracking2.moreOrder;
  var handleClosePopup = function handleClosePopup() {
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
    setShowPopup(false);
  };
  var handleMoreOrderClick = function handleMoreOrderClick() {
    if (disabled) {
      return;
    }
    setShowPopup(true);
    (moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingClick) && tracker.click(moreOrderTracking.trackingClick);
  };
  return /*#__PURE__*/React.createElement(View, _extends({
    style: styles['order-card-with-more-button']
  }, orderCardTracking === null || orderCardTracking === void 0 ? void 0 : orderCardTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: [styles['order-card-with-more-button-btn-wrapper'], isUIOptimisationHotQuestion ? styles['order-card-with-more-button-btn-wrapper-ui-optimisation-hot-question'] : {}]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles['order-card-with-more-button-btn-wrapper-title'], isUIOptimisationHotQuestion ? styles['order-card-with-more-button-btn-wrapper-title-ui-optimisation-hot-question'] : {}]
  }, title), showMoreButton ? /*#__PURE__*/React.createElement(Pressable, _extends({
    style: styles['order-card-with-more-button-btn-wrapper-pressable'],
    onPress: handleMoreOrderClick
  }, moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(Text, {
    style: [styles['order-card-with-more-button-btn-wrapper-text'], disabled ? styles['order-card-with-more-button-btn-wrapper_disabled-text'] : undefined],
    numberOfLines: 1
  }, loadMoreOrderText), disabled ? /*#__PURE__*/React.createElement(ImageIconRightGray, {
    style: styles['order-card-with-more-button-btn-wrapper-img']
  }) : /*#__PURE__*/React.createElement(ImageIconRight, {
    style: styles['order-card-with-more-button-btn-wrapper-img']
  })) : null), /*#__PURE__*/React.createElement(Order, order), /*#__PURE__*/React.createElement(Popup, {
    title: panelTitleText || trans(BUYER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    active: showPopup,
    onClose: function onClose() {
      return handleClosePopup();
    },
    titleStyle: styles['order-card-with-more-button-popup__title'],
    contentContainerStyle: {
      height: screenHeight * 0.8
    },
    contentStyle: [styles['order-card-with-more-button-popup__content'], popupContentStyle],
    contentScrollable: false,
    delayBeforeContentShow: 300
  }, /*#__PURE__*/React.createElement(ProductListTabs, {
    tabs: tabs,
    onLoadMore: onLoadMore,
    defaultSelected: defaultSelected,
    itemText: itemText,
    itemsText: itemsText,
    showOrderId: showOrderId,
    showUserTypeTab: showUserTypeTab,
    userTypeTabs: userTypeTabs,
    onButtonClick: function onButtonClick(params) {
      _onButtonClick === null || _onButtonClick === void 0 ? void 0 : _onButtonClick(params);
      setShowPopup(false);
    } // trackingData={trackingData}
    ,

    componentTrackingData: componentTrackingData,
    showLoading: showLoading
  })));
};
var screenHeight = Dimensions.get('window').height;
var styles = CustomStyleSheet({
  'order-card-with-more-button': {
    width: '100%'
  },
  'order-card-with-more-button-btn-wrapper': {
    paddingVertical: 12,
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.09)'
  },
  'order-card-with-more-button-btn-wrapper_disabled-text': {
    color: 'rgba(0, 0, 0, 0.26)'
  },
  'order-card-with-more-button-btn-wrapper-title': _objectSpread(_objectSpread({
    margin: 0
  }, FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 16,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    flex: 1
  }),
  'order-card-with-more-button-btn-wrapper-pressable': {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 'auto'
  },
  'order-card-with-more-button-btn-wrapper-text': _objectSpread(_objectSpread({
    margin: 0,
    width: 113
  }, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 14,
    textAlign: 'right',
    color: '#ee4d2d'
  }),
  'order-card-with-more-button-btn-wrapper-img': {
    marginLeft: 4,
    width: 12,
    height: 12
  },
  'order-card-with-more-button-popup__title': {
    textAlign: 'center'
  },
  'order-card-with-more-button-popup__content': {
    padding: 0
  },
  'order-card-with-more-button-btn-wrapper-ui-optimisation-hot-question': {
    paddingVertical: 10,
    paddingHorizontal: 10,
    borderBottomWidth: 0,
    paddingBottom: 0
  },
  'order-card-with-more-button-btn-wrapper-title-ui-optimisation-hot-question': {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 16,
    lineHeight: 20,
    fontWeight: '500'
  }
});